import Render from '@Views/components/misc-collapsible-panel.html'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Render
@Component({})
export class MiscCollapsiblePanel extends Vue {

	private _collapsed: boolean

	@Prop({default: true}) collapsed: boolean
	@Prop({default: 'div'}) tag: string

	created() {
		this._collapsed = this.collapsed
	}
    toggle(): void {
		this._collapsed = !this._collapsed
		this.$forceUpdate()
	}
	isToggle(): boolean {
		return !this._collapsed
	}
}